
"use strict";

var zeropadnum = require('./deep-query-api/lib/zeropadnum');

var zeroes = '0.00000000000000000000';

var LOG10E = Math.LOG10E
  , abs    = Math.abs
  , ceil   = Math.ceil
  , floor  = Math.floor
  , log    = Math.log
  , log10  = Math.log10 || function(x) { return log(x) * LOG10E; }
  , pow    = Math.pow
  , round  = Math.round

var NUMBER_FORMATS = exports.NUMBER_FORMATS = [
  'All digits', '000000000', '000000', '000', '00', '0', '0.0', '0.00', '0.000', '0.0000'
];

var DURATION_FORMATS = exports.DURATION_FORMATS = [
  'Auto', 'hh', 'hh:mm', 'hh:mm:ss', 'hh:mm:ss.ms', 'mm', 'mm:ss', 'mm:ss.ms', 'ss', 'ss.ms', 'ms'
];

var upscale =   ['K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y']
  , downscale = ['m', 'μ', 'n', 'p', 'f', 'a', 'z', 'y'];

var numberFormatRe = /^(?:(0\.0+)|(0+))?([kKMBGTPEZYmμnpfazy-])?$/;

var prefixScaleMap = {'-': 0, 'k': 1, 'G': 3};

upscale.forEach(function(prefix, i) { prefixScaleMap[prefix] = i + 1});
downscale.forEach(function(prefix, i) { prefixScaleMap[prefix] = -i - 1});

var SECONDS_MS = 1000
  , MINUTES_MS = 60*SECONDS_MS
  , HOURS_MS   = 60*MINUTES_MS
  , DAYS_MS    = 24*HOURS_MS;

var durationFormatRe = /^(hh)?:?(mm)?:?(ss)?[\.:]?(ms)?$/;
var durationFormatParts = {};

DURATION_FORMATS.forEach(function(format) {
  var maxpart, minpart, matched = format.match(durationFormatRe)
  if (matched) {
    for(var i = 1; i < 5; ++i) {
      if (maxpart === void 0) maxpart = matched[i];
      if (minpart === void 0) minpart = matched[5 - i];
      if (minpart !== void 0 && maxpart !== void 0) {
        durationFormatParts[format] = [maxpart, minpart];
        break;
      }
    }
  }
});

/**
 *  Format `milliseconds` according to `maxpart` and `minpart`
 *
 *  `maxpart`, `minpart` must be one of:
 *
 *  - 'hh', 'mm', 'ss', 'ms'
 *
 *  @param {number} milliseconds
 *  @param {string} maxpart
 *  @param {string} minpart
 *
 *  @return {string}
**/
function durationFixedFormat(milliseconds, maxpart, minpart) {
  var str, part;

  milliseconds = +milliseconds;
  if (isNaN(milliseconds)) return '\u2010';
  if (!isFinite(milliseconds)) return milliseconds < 0 ? '-\u221E' : '\u221E';

  if (maxpart !== 'ms') {

    if (milliseconds < 0) {
      milliseconds = round(-milliseconds);
      str = '-';
    }
    else {
      milliseconds = round(milliseconds);
      str = '';
    }

    if (maxpart === 'hh') {
      part = zeropadnum(floor(milliseconds / HOURS_MS), 2);
      if (maxpart === minpart) return str + part;
      str += part + ':';
      milliseconds %= HOURS_MS;
      maxpart = 'mm';
    }

    if (maxpart === 'mm') {
      part = zeropadnum(floor(milliseconds / MINUTES_MS), 2);
      if (maxpart === minpart) return str + part;
      str += part + ':';
      milliseconds %= MINUTES_MS;
      maxpart = 'ss';
    }

    if (maxpart === 'ss') {
      part = zeropadnum(floor(milliseconds / SECONDS_MS), 2);
      if (maxpart === minpart) return str + part;
      return str + part + '.' + zeropadnum(milliseconds % SECONDS_MS, 3);
    }

  }

  return round(milliseconds).toString();
}

/**
 *  Format `milliseconds` as duration parts
 *
 *  @param {number} milliseconds
 *
 *  @return {string}
**/
function durationAutoFormat(milliseconds) {
  var str, sep, part;

  milliseconds = +milliseconds;
  if (isNaN(milliseconds)) return '\u2010';
  if (!isFinite(milliseconds)) return milliseconds < 0 ? '-\u221E' : '\u221E';

  if (milliseconds < 0) {
    milliseconds = round(-milliseconds);
    str = '-';
  }
  else {
    milliseconds = round(milliseconds);
    str = '';
  }

  if (milliseconds >= DAYS_MS) {
    str += floor(milliseconds / DAYS_MS) + 'd';
    sep = ' ';
    milliseconds %= DAYS_MS;
    if (milliseconds < 1) return str;
  }

  if (milliseconds >= HOURS_MS) {
    part = (milliseconds / HOURS_MS) | 0;
    str += sep === undefined ? part : sep + zeropadnum(part, 2);
    sep = ':';
    milliseconds %= HOURS_MS;
    if (milliseconds < 1) return str + 'h';
  }

  if (sep === ':' || milliseconds >= MINUTES_MS) {
    part = (milliseconds / MINUTES_MS) | 0;
    str += sep === undefined ? part : sep + zeropadnum(part, 2);
    sep = ':';
    milliseconds %= MINUTES_MS;
    if (milliseconds < 1) return str + 'm';
  }

  if (sep === ':' || milliseconds >= SECONDS_MS) {
    part = (milliseconds / SECONDS_MS) | 0;
    str += sep === undefined ? part : sep + zeropadnum(part, 2);
    sep = '.';
    milliseconds %= SECONDS_MS;
    if (milliseconds < 1) return str + 's';
  }

  if (sep === '.') {
    return (str + '.' + zeropadnum(milliseconds, 3) + 's');
  }
  else if (sep !== undefined) {
    return (str + ' 00.' + zeropadnum(milliseconds, 3) + 's');
  }
  else if (milliseconds !== 0) {
    return str + (sep || '') + milliseconds + 'ms';
  }
  else return '0';
}

/**
 *  Format `number` with fixed `precision` and `scale`.
 *
 *  `precision`:
 *
 *  - negative for "all digits"
 *  - 0 no fraction digits
 *  - positive for decimal point precision
 *
 *  `scale`:
 *
 *  - positive for upscaling
 *  - 0 or undefined for no scaling
 *  - negative for downscaling
 *
 *  @param {number} number
 *  @param {number} precision
 *  @param {number} scale
 *
 *  @return {string}
**/
function numberFixedFormat(number, precision, scale) {
  var prefix, str, index, dotshift;

  number = +number;
  if (isNaN(number)) return '\u2010';
  if (!isFinite(number)) return number < 0 ? '-\u221E' : '\u221E';

  scale |= 0;
  precision |= 0;

  if (scale) {
    prefix = scale > 0 ? upscale[scale - 1] : downscale[-scale - 1];
    if (prefix === undefined) {
      prefix = (scale > 0) ? 'e+' + scale * 3
                           : 'e' + scale * 3;
    }

    if (precision < 0) { /* all digits with scale - tough luck */
      if (number === 0) return '0' + prefix;

      str = abs(number).toExponential();
      index = str.indexOf('e');
      dotshift = str.substr(index + 1) - scale*3;

      if (dotshift === 0) {
        str = str.substr(0, index);
      }
      else if (dotshift > 21 || dotshift < -21) {
        return str; // too big or too small
      }
      else {
        if (index === 1) {
          str = str.substr(0, index);
        }
        else {
          str = str[0] + str.slice(2, index);
          index -= 1;
        }

        if (dotshift < 0) {
          str = zeroes.substr(0, -dotshift + 1) + str;
        }
        else if (dotshift >= index - 1) {
          str += zeroes.substr(2, dotshift - index + 1);
        }
        else {
          str = str.substr(0, dotshift + 1) + '.' + str.substr(dotshift + 1);
        }
      }

      if (number < 0) str = '-' + str;
    }
    else {
      number *= pow(10, -scale * 3);
      str = number.toFixed(precision);
    }

    return str + prefix;
  }
  else if (precision < 0) {
    return (number % 1 === 0) ? number.toFixed(0)
                              : number.toString();
  }

  return number.toFixed(precision);
}

/**
 *  Format `number` according to `precision` indicator.
 *
 *  `precision`:
 *
 *  - 0 or undefined for "auto"
 *  - -1 for "all integer digits"
 *  - negative for integer precision
 *  - positive for floating point precision
 *
 *  @param {number} number
 *  @param {number} precision
 *
 *  @return {string}
**/
function numberAutoFormat(number, precision) {
  var absolute, magnitude, scale, prefix;

  number = +number;
  if (isNaN(number)) return '\u2010';
  if (!isFinite(number)) return number < 0 ? '-\u221E' : '\u221E';

  precision |= 0;

  if (number === 0) {
    if (precision <= 0) return '0';
    return number.toPrecision(precision);
  }

  absolute = abs(number);

  /* auto */
  if (precision === 0) {
    if (absolute < 999.5) {
      if (number % 1 === 0) return number.toFixed(0);
      if (absolute >= 0.01) {
        scale = number.toPrecision(3);
        prefix = scale.length - 1;
        if (scale.indexOf('.') !== -1) {
          while (scale[prefix] === '0') --prefix;
          if (scale[prefix] === '.') --prefix;
        }
        return scale.substr(0, prefix + 1);
      }
    }
    else {
      absolute = round(absolute);
    }
    scale = absolute.toExponential();
    precision = scale.indexOf('e');
    if (precision > 4) precision = 3;
    else if (precision > 1) precision -= 1;
  }

  if (precision < 0) {
    /* integer format */
    precision = -precision;
    if (precision === 1) return number.toFixed(0);
    absolute = round(absolute);
    magnitude = floor(log10(absolute));
    if (magnitude < precision) return number.toFixed(0);
    if (number < 0) number = -absolute;
  }
  else {
    magnitude = floor(log10(absolute));
  }

  if (magnitude < -1) {
    /* small numbers (less than 0.1) si format */
    scale = (2 - magnitude) / 3|0;
    number *= pow(10, scale * 3);
    prefix = downscale[scale - 1];
    if (prefix === undefined) prefix = 'e-' + scale * 3;
    magnitude = 3 + (magnitude + 1) % 3;
  }
  else {
    /* fixed precision format */
    if (magnitude < 3) {
      if (magnitude < precision) return number.toFixed(precision - 1);
      scale = 1 + (magnitude / 3|0);
      magnitude -= 2;
    }
    else {
      scale = magnitude / 3|0;
    }
    /* si format */
    number *= pow(10, -scale * 3);
    prefix = upscale[scale - 1];
    if (prefix === undefined) prefix = 'e+' + scale * 3;
    magnitude = 1 + magnitude % 3;
  }

  if (precision < magnitude) precision = magnitude;

  return number.toPrecision(precision) + prefix;
}

/**
 *  Convert `format` argument to `{precision, scale}` or `precision`
 *
 *  @param {string} format
 *
 *  @return {Object|number}
**/
function precisionScaleFromFormat(format) {
  var matched, template, precision, scale;

  if ('string' === typeof format) {
    matched = format.match(numberFormatRe);
  }

  if (matched) {
    template = matched[1];
    if (template != null) {
      precision = template.length - 1;
    }
    else if ((template = matched[2]) != null) {
      precision = -template.length;
    }

    template = matched[3];
    if (template != null) { /* fixed denomination */
      scale = prefixScaleMap[template];
      if (precision === undefined) precision = -1; /* all digits */
      else if (precision < 0) precision = 0; /* integer */
      else precision -= 1; /* fraction */
    }
  }

  if (precision === undefined) precision = 0;

  if (scale === undefined) return precision;
  return {precision: precision, scale: scale};
}

/**
 *  Extract precision part from `format` argument
 *
 *  @param {string} format
 *
 *  @return {string}
**/
exports.precisionPartFromFormat = function(format) {
  var matched;

  if ('string' === typeof format) {
    matched = format.match(numberFormatRe);
  }

  return matched && (matched[1] || matched[2]) || "";
};

/**
 *  Extract prefix part from `format` argument
 *
 *  @param {string} format
 *
 *  @return {string}
**/
exports.prefixPartFromFormat = function(format) {
  var matched;

  if ('string' === typeof format) {
    matched = format.match(numberFormatRe);
  }

  return matched && matched[3] || "";
};

/**
 *  Convert `format` argument to [`maxpart`, 'minpart']
 *
 *  `format` must be one of `DURATION_FORMATS`
 *
 *  @param {string} format
 *
 *  @return {Array|undefined}
**/
function timePartsFromFormat(format) {
  return durationFormatParts[format];
};

/**
 *  return `value` format function according to `format` and `multiplier`
 *
 *  `format` must be one of `DURATION_FORMATS`
 *
 *  @param {string} format
 *  @param {number} [multiplier]
 *  @param {string} [unit]
 *  @param {boolean} [unitAsPrefix]
 *
 *  @return {Function}
**/
exports.createDurationFormatFn = function(format, multiplier, unit, unitAsPrefix) {
  var parts = timePartsFromFormat(format), maxpart, minpart;

  multiplier = multiplier ? (+multiplier) : 1;
  if (!isFinite(multiplier)) multiplier = 1;

  if (unit) {
    unit = unitAsPrefix ? unit + ' ' : ' ' + unit;
  }

  if (parts !== undefined) {
    maxpart = parts[0], minpart = parts[1];
    if (unit) {
      if (unitAsPrefix) {
        return function(value) {
          return unit + durationFixedFormat(value*multiplier, maxpart, minpart);
        };
      }
      else return function(value) {
        return durationFixedFormat(value*multiplier, maxpart, minpart) + unit;
      };
    }
    else return function(value) {
      return durationFixedFormat(value*multiplier, maxpart, minpart);
    };
  }
  else {
    if (unit) {
      if (unitAsPrefix) {
        return function(value) {
          return unit + durationAutoFormat(value*multiplier);
        };
      }
      else return function(value) {
        return durationAutoFormat(value*multiplier) + unit;
      };
    }
    else return function(value) {
      return durationAutoFormat(value*multiplier);
    };
  }
};

/**
 *  Format `value` according to `format` and `multiplier`
 *
 *  `format` must be one of `DURATION_FORMATS`
 *
 *  @param {number} value
 *  @param {string} format
 *  @param {number} [multiplier]
 *
 *  @return {string}
**/
exports.durationFormat = function(value, format, multiplier) {
  var parts = timePartsFromFormat(format);

  if (multiplier) value *= multiplier;

  if (parts !== undefined) {
    return durationFixedFormat(value, parts[0], parts[1]);
  }
  else return durationAutoFormat(value);
};

/**
 *  Format `number` according to `format` argument
 *
 *  `format` must be one of `NUMBER_FORMATS`
 *
 *  @param {number} number
 *  @param {string} format
 *
 *  @return {string}
**/
exports.numberFormat = function(number, format) {
  var precision = precisionScaleFromFormat(format);

  if ('number' === typeof precision) {
    return numberAutoFormat(number, precision);
  }
  else {
    return numberFixedFormat(number, precision.precision, precision.scale);
  }
};

/**
 *  return `value` format function according to `format` argument
 *
 *  `format` must be one of `NUMBER_FORMATS`
 *
 *  @param {string} format
 *  @param {string} [unit]
 *  @param {boolean} [unitAsPrefix]
 *
 *  @return {Function}
**/
exports.createNumberFormatFn = function(format, unit, unitAsPrefix) {
  var scale
    , precision = precisionScaleFromFormat(format);

  if (unit) {
    unit = unitAsPrefix ? unit + ' ' : ' ' + unit;
  }

  if ('number' === typeof precision) {
    if (unit) {
      if (unitAsPrefix) {
        return function(number) {
          return unit + numberAutoFormat(number, precision);
        };
      }
      else return function(number) {
        return numberAutoFormat(number, precision) + unit;
      };
    }
    else return function(number) {
      return numberAutoFormat(number, precision);
    };
  }
  else {
    scale = precision.scale, precision = precision.precision;
    if (unit) {
      if (unitAsPrefix) {
        return function(number) {
          return unit + numberFixedFormat(number, precision, scale);
        };
      }
      else return function(number) {
        return numberFixedFormat(number, precision, scale) + unit;
      };
    }
    else return function(number) {
      return numberFixedFormat(number, precision, scale);
    };
  }
};

exports.durationFixedFormat = durationFixedFormat;
exports.durationAutoFormat = durationAutoFormat;
exports.numberFixedFormat = numberFixedFormat;
exports.numberAutoFormat = numberAutoFormat;
exports.precisionScaleFromFormat = precisionScaleFromFormat;

// var nf = require('./lib/format').numberFormat
// var tf = require('./lib/format').durationAutoFormat
